module.exports = __webpack_public_path__ + "img/icon-subscribe-1.8580e89a.svg";